import styled from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const ShopItemWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	border: 1px solid transparent;
	transition:
		transform 0.3s ease,
		border 0.3s ease;
	height: 100%;
	position: relative;

	&:hover {
		transform: scale(1.02);
		border: 1px solid ${({ theme }) => theme.colors.transparent.light30};
	}
`;

export const ChipWrapper = styled.div`
	position: absolute;
	display: flex;
	gap: 6px;
	top: 6px;
	left: 8px;
	flex-wrap: wrap;
`;

export const ShopItemImage = styled.img<{ $disabled: boolean }>`
	height: 136px;
	width: auto;
	object-fit: contain;
	margin: 8px;
	${({ $disabled }) => $disabled && 'opacity: 0.5;'};

	@media (${BREAKPOINTS.MOBILE}) {
		height: 68px;
	}
`;

export const ShopItemTitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	padding: 6px 16px;
`;

export const ShopItemReward = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 6px;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}

	@media (${BREAKPOINTS.MOBILE}) {
		padding: 0 8px;
	}
`;

export const ShopItemCount = styled.div`
	padding: 4px 6px;
	background-color: ${({ theme }) => theme.colors.background.input};
	border-radius: 16px;

	font-size: 12px;
	font-weight: 500;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const ShopItemRewardIcon = styled.img`
	width: 24px;
	height: 24px;
`;

export const ShopItemInfo = styled.div`
	margin-top: 6px;
	padding: 0 16px;

	@media (${BREAKPOINTS.MOBILE}) {
		padding: 0 8px;
	}
`;

export const ShopItemName = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 8px;

	@media (${BREAKPOINTS.MOBILE}) {
		font-size: 13px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.text.subtitle};
		margin-bottom: 14px;
	}
`;

export const ShopItemDescription = styled.div`
	margin-bottom: 8px;

	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (${BREAKPOINTS.MOBILE}) {
		display: none;
	}
`;

export const ShopItemTextDescInner = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 18px;
`;

export const Divider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	width: 100%;
`;

export const ShopItemButtons = styled.div`
	display: flex;
	gap: 8px;
	padding: 0 16px;
	margin-bottom: 16px;
	justify-content: end;
	margin-top: auto;

	@media (${BREAKPOINTS.MOBILE}) {
		padding: 0 8px;
		margin-bottom: 8px;
	}
`;
